// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"8837b8e5","184":"15905e88","210":"23957921","355":"635de505","720":"ec186b30","989":"96b5d14f"}[chunkId] + ".chunk.js";
};